import { render } from "./UnsupportedBrowser.vue?vue&type=template&id=d9664060&scoped=true"
import script from "./UnsupportedBrowser.vue?vue&type=script&lang=js"
export * from "./UnsupportedBrowser.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d9664060"

export default script